<template>
  <b-card no-body tag="article" class="product-card h-100 text-center">
    <div v-if="featuredBannerLang">
      <b-link
        :to="product.productRoute || productRoute"
        target="_blank"
      >
        <b-card-img :src="featuredBannerLang" :alt="product.description" top></b-card-img>
      </b-link>
    </div>
    <div v-else>
      <b-row>
        <b-col cols="5">
          <b-link :to="productRoute">
            <b-card-img
              :src="(product.picture && product.picture.picture)? product.picture.picture: fallback"
              :alt="product.description"
              top
              @error="imageLoadError"
            ></b-card-img>
          </b-link>
        </b-col>
        <b-col cols="7">
          <b-card-body class="d-flex flex-column" v-bind:class="{ 'pt-0': discount }">
            <div class="mt-auto">
              <b-container fluid v-if="price">
                <b-row align-v="end">
                  <b-col class="m-0 p-0">
                    <div v-if="discount" class="discount-type">
                      ({{ $t("product_banner_card.pack_offer") }} x{{ discountPackQuantity }})
                    </div>
                    <div v-if="discount" class="no-discount-price">
                      {{ $formatMoney(priceBefore, currency) }}
                    </div>
                    <div class="product-price">
                      {{ $formatMoney(price, currency) }}
                    </div>
                  </b-col>
                  <b-col v-if="discount" cols="4" class="m-0 p-0">
                    <div v-if="discount" class="discount-box p-2">
                      -{{ discountPercent }}%
                    </div>
                  </b-col>
                </b-row>
              </b-container>
              <div class="product-name mt-3">
                <b-link :to="productRoute">{{ product.description }}</b-link>
              </div>
              <b-button
                variant="cart"
                class="mb-2 px-2"
                v-bind:class="{ 'mt-4': discount, 'mt-5': !discount }"
                :disabled="!price"
                @click="buyProduct()"
              >
                <vue-element-loading :active="to_cart_loading" />
                {{ $t('product_banner_card.add') }}
              </b-button>
            </div>
          </b-card-body>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>


<script>
import { ProductCardMixin } from "@/mixins/ProductCardMixin";
import { mapState } from "vuex";

export default {
  mixins: [ProductCardMixin],
  computed: {
    ...mapState({
      active_lang: (state) => state.i18nmap.active_lang,
    }),
    featuredBannerLang: function () {
      var default_banner = "";
      if (this.product.banners) {
        var langtag = this.active_lang.langtag;
        for (let i = 0; i < this.product.banners.length; i++) {
          if (this.product.banners[i].langtag == langtag.replace("-", "_")) {
            return this.product.banners[i].image;
          }
          if (this.product.banners[i].langtag == "default") {
            default_banner = this.product.banners[i].image;
          }
        }
      }
      if (default_banner) {
        return default_banner;
      }
      return null;
    },
  },
  name: "product-banner-card",
  fallbackI18n: {
    messages: {
      und: {
        product_banner_card: {
          add: "Add",
          pack_offer: "Pack",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.product-card {
  background-color: $main-bg-color;
  border: 0px;
}

.product-price {
  color: $gray-550;
  font-size: $font-size-medium * 1.5;
  font-weight: bold;
}

.product-name {
  font-size: $font-size-medium;
  font-weight: bold;
}

.product-name a {
  color: $text-main-color;
  text-decoration: none;
}

.discount-type {
  color: $grey5-color;
}

.no-discount-price {
  color: $grey5-color;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
  text-decoration: line-through;
}

.discount-box {
  background-color: $discount-bg-color;
  color: $white;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}
</style>
